import React from "react";
import logo from "../../../../../assets/Images/logo.png";
import { DashboardDesktopMainMenu, MenuLink } from "../styles";
import CustomButton from "../../../MainComponent/CustomBtn";
const DashboardDesktopMenu = (props) => {
 
  return (
    <DashboardDesktopMainMenu maxWidth="xl">
      <MenuLink href="/" p="0px">
        <img src={logo} width="150" alt="Logo" /> 
      </MenuLink>
      <div style={{display:"flex" , alignItems:"center"}}>
        {props.menuList.map((value, i) => <MenuLink key={i} href={value.link} target={value.target} className={value.customClass}>{value.title}</MenuLink> )}
        <MenuLink p="0 5px 0 10px">
          <CustomButton w="150px" c="#fff" bgc="#53616f8a" hbgc="#fff" hc="#000">
          Connect Wallet
          </CustomButton>
        </MenuLink>
        
      </div>
    </DashboardDesktopMainMenu>
  );
};

export default DashboardDesktopMenu;
